const euCommon = {
  common: {
    sweetenersList: {
      'option-1': 'Free shipping on orders under',
      'option-2': 'Extended 200 day Returns',
      'option-3': 'No EU custom or duty fees'
    },
    cart: {
      multibuy: {
        't-shirts': {
          label: '3 for €150',
          discount: 'Save €15',
          eligiblePrice: '55.00'
        },
        trunks: {
          label: '3 for €80 or 5 for €120',
          discount: '',
          eligiblPrice: '30.00'
        },
        'heavyweight-tee': {
          label: '3 for €150',
          discount: 'Save €45',
          eligiblePrice: '65.00'
        }
      }
    }
  }
}

module.exports = euCommon
